import React from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { faPaperPlane } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Button from "./CustomButton";
import { compose, setDisplayName } from "recompose";
import NextForm from "../containers/NextForm";

export const ResetPasswordForm = ({
  authenticating,
  failAuth,
  onSubmit,
  inputs,
  focusNextField
}) => {
  return (
    <Formik
      onSubmit={onSubmit}
      validate={validate}
      initialValues={{
        password: "",
        password_confirmation: ""
      }}
      render={props => (
        <Form>
          {failAuth && <Alert color="danger">{failAuth}</Alert>}
          <Field
            innerRef={input => (inputs.password = input)}
            onKeyPress={focusNextField("password_confirmation")}
            name="password"
            type="password"
            component={TextInput}
            placeholder="Password"
            label="Password"
          />
          <Field
            innerRef={input => (inputs.password_confirmation = input)}
            name="password_confirmation"
            type="password"
            component={TextInput}
            placeholder="Password Confirmation"
            label="Password Confirmation"
          />
          <div>
            <Button
              fill
              block
              type="submit"
              disabled={authenticating}
              color="info"
            >
              Send <FontAwesomeIcon icon={faPaperPlane} />
            </Button>
          </div>
        </Form>
      )}
    />
  );
};

ResetPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  authenticating: PropTypes.bool.isRequired,
  failAuth: PropTypes.string
};

export const validate = (values = {}) => {
  const errors = {};
  if (!values.password) {
    errors.password = "Required";
  }
  if (!values.password_confirmation) {
    errors.password_confirmation = "Required";
  } else if (values.password !== values.password_confirmation) {
    errors.password_confirmation = "Passwords must match";
  }
  return errors;
};

export default compose(
  setDisplayName("ResetPasswordForm"),
  NextForm
)(ResetPasswordForm);
